import AccountUserSelect from "Components/Shared/AccountUserSelect";
import { Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import { isEmpty } from "lodash";
import React, { Fragment } from "react";
import { Button, Form } from "semantic-ui-react";

const ClientUser = () => {
  const { device, update } = useDevice();
  if (!device) return <Fragment />;

  return (
    <Formik
      initialValues={device}
      //   validationSchema={DeviceSchema}
      onSubmit={(values, actions) => {
        update(values);
      }}
    >
      {(props: any) => (
        <Form onSubmit={props.handleSubmit}>
          <AccountUserSelect name='client.user' label='Select User' />

          <Button primary type='submit' disabled={!isEmpty(props.errors)}>
            Submit
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default ClientUser;
